var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.23125 8.54358C0.084375 8.39983 0 8.20608 0 7.99983C0 7.79358 0.084375 7.59983 0.23125 7.45608L5.73125 2.20608C6.03125 1.91858 6.50625 1.93108 6.79063 2.23108C7.075 2.53108 7.06563 3.00608 6.76562 3.29046L2.62188 7.24983H13.25C13.6656 7.24983 14 7.58421 14 7.99983C14 8.41546 13.6656 8.74983 13.25 8.74983H2.62188L6.76875 12.7061C7.06875 12.9936 7.07812 13.4655 6.79375 13.7655C6.50937 14.0655 6.03438 14.0748 5.73438 13.7905L0.234375 8.54046L0.23125 8.54358Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBack);
export default __webpack_public_path__ + "static/media/goBack.798750791529d85c4f74b2580542fb24.svg";
export { ForwardRef as ReactComponent };